import { LoanSetupScreen } from "@/screens/loans/components/setup/LoanSetupScreen"
import { MultiQuestionScreen } from "@/screens/prequal/MultiQuestionScreen"
import { type PreQualState, useFinishedPreQual } from "@/stores/preQual"
import { View } from "react-native"
import { setupScreenAccordionOpened } from "@/analytics/events/loans"

const QUESTIONS: Array<keyof PreQualState> = [
  "propertiesFlipped",
  "creditScore",
  "cashAvailable",
]

export const LoanQualificationScreen = ({
  onSubmit,
  backButton,
}: {
  onSubmit: () => Promise<void>
  backButton?: () => void
}) => {
  const isPrequalDone = useFinishedPreQual(QUESTIONS)

  return (
    <LoanSetupScreen
      title={"Check Qualification"}
      subTitle={"Let’s take a closer look at your profile"}
      stepData={[1, 4]}
      nextButtonProps={{
        title: "Next: Property Info",
        disabled: !isPrequalDone,
      }}
      onSubmit={onSubmit}
      backButton={backButton}
    >
      <View testID={"loan-qualification-screen"}>
        <MultiQuestionScreen
          className={"px-5 pt-0 pb-5"}
          questions={QUESTIONS}
          activeChanged={(active) => {
            setupScreenAccordionOpened({
              currentScreen: "Loan Setup - Qualification",
              accordionKey: active,
            })
          }}
        />
      </View>
    </LoanSetupScreen>
  )
}
